import * as React from 'react';
import { Label } from '../elements/index';
import classnames from 'classnames';
// removed import of scss-style
/**
 * Generic navigation bar.
 */
const Navbar = ({ onChange, options, value }) => {
    const forwardValue = (e // e: React.MouseEvent<HTMLParagraphElement, MouseEvent>
    ) => {
        onChange(e.currentTarget.textContent);
    };
    return (React.createElement("div", { className: "ReadReportMenuContent ReadReportMenuContentMenu" }, options === null || options === void 0 ? void 0 : options.map(option => {
        const style = classnames('ReadReportMenuContent__Item', {
            'ReadReportMenuContent__Item--active': option === value
        });
        return (React.createElement(Label, { key: value, className: style, onClick: forwardValue }, option));
    })));
};
export default Navbar;
